<template>
  <v-select
    :items="decoratedRooftops"
    item-text="name"
    item-value="id"
    v-model="rooftop_id"
    label="Select a Rooftop"
    :disable="false"
    append-outer-icon="mdi-domain"
    no-data-text="No Rooftops"
    persistent-hint
    hint="Select a Rooftop"
  />
</template>

<script>
import { DealerRooftopApi } from '@/services'

export default {
  name: 'rooftop-select',
  props: {
    dealerId: {
      type: [Number, String],
      required: true
    },
    value: {
      type: [Number, String],
      required: false,
      default: null
    },
    loadRooftopDefault: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  data () {
    return {
      rooftops: []
    }
  },
  computed: {
    decoratedRooftops () {
      return this.rooftops.map((rooftop) => {
        const rtName = rooftop.default_rooftop ? `${rooftop.name} (Default)` : rooftop.name
        return {
          ...rooftop,
          name: rtName
        }
      })
    },
    rooftop_id: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  },
  watch: {
    dealerId: {
      immediate: true,
      handler: function (newVal, oldVal) {
        if (newVal) {
          this.fetchDealerRooftops()
        }
      }
    }
  },
  methods: {
    fetchDealerRooftops () {
      DealerRooftopApi.fetchRooftops(this.dealerId)
        .then((response) => {
          this.rooftops = response.data
          return this.rooftops
        }).then((rooftops) => {
          if (this.loadRooftopDefault && !this.value) {
            this.rooftop_id = rooftops.find((rooftop) => rooftop.default_rooftop).id
          }
        }).catch((error) => {
          this.$logger.error(error.message)
          this.$flash({
            showClose: true,
            message: `Failed to load Dealer Rooftops. ${error.message}`,
            type: 'error',
            duration: 5000
          })
        })
    }
  }
}
</script>
